export function formatCurrency(number, currency = "KRW") {
	if (!number) {
		number = 0;
	}
	return number.toLocaleString("ko-KR", {
		style: "currency",
		currency: currency,
		maximumSignificantDigits: 10,
	});
}
